import axios from "axios";
import querystring from "querystring";
import { getUserData, configFetch } from "./config"; // Mengimpor getUserData dan configFetch dari config.js

const HOSTNAME = process.env.REACT_APP_API_URL || "http://localhost:8080";

const API_SERVICES = {
  RoomProductIndex: `${HOSTNAME}/roomproduct/index`,
  RoomProductAdd: `${HOSTNAME}/roomproduct/add`,
  RoomProductEdit: `${HOSTNAME}/roomproduct/edit`,
  RoomProductUpdate: `${HOSTNAME}/roomproduct/update`,
  RoomProductDelete: `${HOSTNAME}/roomproduct/delete`,
};

// Function to fetch room products
export const fetchRoomProducts = async (params) => {
  try {
    const userData = getUserData(); // Ensure token is valid and get user data

    const url = `${API_SERVICES.RoomProductIndex}?${querystring.stringify(
      params
    )}`;

    const response = await axios(
      configFetch(url, "get", null, true, {
        Authorization: `Bearer ${userData.token}`,
      })
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching room products:", error.message);
    throw error;
  }
};

// Function to add a room product
export const addRoomProduct = async (data) => {
  try {
    const userData = getUserData(); // Ensure token is valid and get user data
    const currentDate = new Date().toISOString().split("T")[0];
    // Menambahkan id_user dan field lain yang diperlukan
    const payload = {
      ...data,
      id_company: 16,
      id_branch: 56,
      id_user: userData.userId,
      tgl_data: currentDate,
      tgl_valid: currentDate,
    };

    const response = await axios(
      configFetch(API_SERVICES.RoomProductAdd, "post", payload, true, {
        Authorization: `Bearer ${userData.token}`,
      })
    );
    return response.data;
  } catch (error) {
    console.error("Error adding room product:", error.message);
    throw error;
  }
};

// Function to update a room product
export const updateRoomProduct = async (data) => {
  try {
    const userData = getUserData(); // Ensure token is valid and get user data
    const currentDate = new Date().toISOString().split("T")[0];
    // Menambahkan id_user dan field lain yang diperlukan
    const payload = {
      ...data,
      id_company: 16,
      id_branch: 56,
      id_user: userData.userId,
      tgl_data: currentDate,
      tgl_valid: currentDate,
    };

    const url = `${API_SERVICES.RoomProductUpdate}`;
    const response = await axios(
      configFetch(url, "put", payload, true, {
        Authorization: `Bearer ${userData.token}`,
      })
    );
    return response.data;
  } catch (error) {
    console.error("Error updating room product:", error.message);
    throw error;
  }
};

// Function to delete a room product
export const deleteRoomProduct = async (id) => {
  try {
    const userData = getUserData(); // Ensure token is valid and get user data

    const url = `${API_SERVICES.RoomProductDelete}`;
    await axios(
      configFetch(url, "delete", id, false, {
        Authorization: `Bearer ${userData.token}`,
      })
    );
  } catch (error) {
    console.error("Error deleting room product:", error.message);
    throw error;
  }
};
